var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30147 17.1176C4.01795 17.1176 1.88931 16.4534 0.0976562 15.3075C1.61883 15.4059 4.30335 15.1702 5.97312 13.5775C3.46124 13.4622 2.32843 11.5357 2.18067 10.7124C2.3941 10.7947 3.41199 10.8935 3.9866 10.663C1.09711 9.93852 0.65384 7.40279 0.752346 6.62889C1.29412 7.00761 2.21351 7.13933 2.57469 7.1064C-0.117784 5.1799 0.850851 2.28192 1.32696 1.65622C3.25918 4.33315 6.15497 5.83661 9.73745 5.92024C9.66991 5.62399 9.63424 5.31556 9.63424 4.99878C9.63424 2.72532 11.4718 0.882324 13.7386 0.882324C14.923 0.882324 15.9902 1.38544 16.7393 2.19021C17.5308 2.00475 18.7219 1.57061 19.3042 1.19517C19.0107 2.24899 18.0969 3.12808 17.5442 3.45391C17.5488 3.46499 17.5397 3.44278 17.5442 3.45391C18.0297 3.38047 19.3434 3.128 19.8624 2.77589C19.6057 3.36791 18.6369 4.35225 17.8419 4.90333C17.9898 11.4268 12.9987 17.1176 6.30147 17.1176Z",
    fill: "#47ACDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d463b4b932e90d38eb25cb34d0606f89.svg";
export { ForwardRef as ReactComponent };